import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getLocale } from "@gamedev-web/gamedev-sdk-core";

import { useHeadScript } from "./scriptHelpers";

interface onConsentChangedResponse {
  Advertising: boolean;
  Analytics: boolean;
  Required: boolean;
  SocialMedia: boolean;
}

export const useCookieConsent = () => {
  const locale = useSelector(getLocale);

  // Setting Clarity script for heat maps and data recording, only for Prod
  const [clarityScript, setClarityScript] = useState("");
  useHeadScript(clarityScript, "text/javascript");

  useEffect(() => {
    const loadClarityScript = (cookies?: onConsentChangedResponse) => {
      const isConsentRequired = window.WcpConsent.siteConsent.isConsentRequired;
      if (!isConsentRequired || (isConsentRequired && cookies?.Analytics === true)) {
        if (!clarityScript && window?.location?.origin === "https://developer.microsoft.com") {
          setClarityScript(
            "https://developer.microsoft.com/games/partner/static/scripts/clarity.js"
          );
        }
      }
    };

    const onConsentChanged = (cookies?: onConsentChangedResponse) => {
      loadClarityScript(cookies);
    };

    const waitForConsentAndLoad = (loadConsentTryLimit: number) => {
      if (loadConsentTryLimit <= 0) {
        return;
      }

      if (!window?.WcpConsent?.siteConsent) {
        // Because the WcpConsent parameter is being set by the UHF and it may take a few
        // seconds to load, we unfortunately have to set a delay here until it's loaded.
        // Otherwise, it'll cause a page crash.
        setTimeout(() => waitForConsentAndLoad(loadConsentTryLimit - 1), 1000);
      } else {
        window.WcpConsent.onConsentChanged(onConsentChanged);
        onConsentChanged(undefined);
      }
    };
    if (!clarityScript) {
      waitForConsentAndLoad(4);
    }
  }, [clarityScript, locale]);
};
